import { createCrud } from '@lumahealthhq/ui-model';
var basePath = 'queuemanagertemplates';
var crud = createCrud(basePath);

/* Default queries */
export var useQueueManagerTemplateCount = crud.makeCount();
export var useQueueManagerTemplateById = crud.makeFindById();
export var useQueueManagerTemplateByIds = crud.makeFindByIds();
export var useQueueManagerTemplateMany = crud.makeFindMany();
export var useQueueManagerTemplateOne = crud.makeFindOne();
export var useQueueManagerTemplatePagination = crud.makePagination();

/* Default mutations */
export var useQueueManagerTemplateCreateOne = crud.makeCreateOne();
export var useQueueManagerTemplateUpdateOne = crud.makeUpdateOne();
export var useQueueManagerTemplateRemoveById = crud.makeRemoveById();